import { useCallback } from 'react';
import I18n from 'I18n';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { SearchInput as FoundationsSearchInput } from 'foundations-components/transitional/components/SearchInput';
import { jsx as _jsx } from "react/jsx-runtime";
export const SearchInput = ({
  disabled = false,
  error,
  label,
  onChange,
  value = '',
  use = 'default',
  autoFocus
}) => {
  const placeholder = I18n.text(label);
  const searchInputChangeHandler = useCallback(event => {
    onChange(event.target.value);
  }, [onChange]);
  return /*#__PURE__*/_jsx(UIFormControl, {
    "aria-label": placeholder,
    "data-test-id": "search-input",
    children: /*#__PURE__*/_jsx(FoundationsSearchInput, {
      "data-test-id": "search-input-form",
      disabled: disabled,
      error: Boolean(error),
      autoFocus: autoFocus,
      onChange: searchInputChangeHandler,
      placeholder: placeholder,
      value: value,
      use: use
    })
  });
};